import React, { ComponentPropsWithoutRef, FC } from 'react';

import { useTheme } from '@mui/material';

import { Svg } from '~/assets/icons/styles';

const ChatBotIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => {
  const theme = useTheme();

  return (
    <Svg
      width="38"
      height="46"
      viewBox="0 0 38 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      svgColor={theme.palette.common.primary}
      {...props}
    >
      <g id="Robot">
        <g id="Group 1">
          <path
            id="Vector"
            d="M1.33443 33.1964C1.55911 31.0942 0.322384 26.5811 3.55774 26.2841C2.78016 29.1444 3.12402 33.2237 3.66129 35.6288C2.36793 35.5682 1.33634 34.5015 1.33634 33.1984L1.33443 33.1964ZM34.7293 35.6464C34.3933 37.1097 33.8071 38.5105 33.0354 39.5987H33.0335C29.425 44.6042 22.2802 44.7976 16.4132 44.5123C10.8529 44.2623 5.0875 41.8826 3.79609 36.1035C3.12987 33.4601 2.77041 29.3671 3.57925 26.2646C5.31415 19.4696 12.2245 14.849 19.207 14.9428C26.1877 14.849 33.0941 19.4657 34.8329 26.2587C35.6222 29.1424 35.2744 33.2179 34.7313 35.6464H34.7293ZM37.1968 33.1964C37.1968 34.5386 36.0988 35.6327 34.7508 35.6307C35.29 33.214 35.6358 29.1483 34.8543 26.2763C38.2206 26.4463 36.98 31.0747 37.1968 33.1984V33.1964ZM34.8485 26.2587C30.7691 11.2503 7.62929 11.262 3.56165 26.2666C0.304804 26.5577 1.53956 31.0883 1.31879 33.1964C1.31879 34.5093 2.36012 35.5838 3.6652 35.6444C4.83744 41.7556 10.5853 44.2544 16.4152 44.5299C22.2841 44.8152 29.4308 44.6217 33.0452 39.6163H33.0471C33.8247 38.5222 34.4108 37.1175 34.7488 35.6464C36.1067 35.6503 37.2144 34.5503 37.2144 33.1964C36.9995 31.0571 38.2382 26.4287 34.8504 26.2587H34.8485Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M5.44705 34.1709C4.03647 27.288 6.65253 20.7079 13.4437 17.9219C13.4456 17.9238 15.1024 19.5474 15.1043 19.5493H23.3041L24.9667 17.9219C31.7637 20.7157 34.3719 27.2841 32.9632 34.1709M32.9593 34.1885C32.3732 38.2894 29.4739 41.2649 25.3164 42.1538C19.3029 43.3026 9.84096 43.6426 6.51768 37.4551C5.98432 36.4334 5.6561 35.3197 5.45096 34.1885M24.9686 17.9043H24.9628L23.2982 19.5337H15.1121L13.4495 17.9023C6.65835 20.6454 4.00133 27.372 5.43536 34.1827C6.59783 42.4449 15.5536 43.2909 22.4073 42.6599C26.1955 42.2926 29.9916 41.0246 31.8106 37.6505C32.9652 35.5307 33.2621 33.0515 33.3071 30.4335C33.6158 25.0041 30.0385 19.9283 24.9706 17.9062L24.9686 17.9043Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M26.2281 32.1972C27.2409 31.7777 27.7219 30.6165 27.3024 29.6037C26.8829 28.5909 25.7217 28.1099 24.7089 28.5295C23.696 28.949 23.2151 30.1101 23.6346 31.1229C24.0541 32.1358 25.2153 32.6167 26.2281 32.1972Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M13.8179 32.1972C14.8308 31.7777 15.3118 30.6165 14.8922 29.6037C14.4727 28.5909 13.3115 28.1099 12.2987 28.5295C11.2859 28.949 10.8049 30.1101 11.2245 31.1229C11.644 32.1358 12.8051 32.6167 13.8179 32.1972Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_5"
            d="M15.6484 36.2148H22.8772"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_6"
            d="M18.8012 11.1536C18.8012 10.7238 19.1431 10.3741 19.5671 10.3741C19.991 10.3741 20.333 10.7218 20.333 11.1536C20.333 11.5854 19.991 11.9331 19.5671 11.9331C19.1431 11.9331 18.8012 11.5854 18.8012 11.1536ZM19.2799 9.18815C19.0572 9.18815 18.8774 9.0045 18.8774 8.77787C18.8774 8.2406 18.9517 7.77757 19.1021 7.38682C19.2115 7.09181 19.3893 6.7968 19.6316 6.49788C19.8113 6.28102 20.1337 5.96256 20.5986 5.54447C21.0636 5.12637 21.3665 4.79424 21.5071 4.54612C21.6478 4.298 21.7162 4.02643 21.7162 3.73337C21.7162 3.20196 21.511 2.73502 21.1047 2.3306C20.6963 1.92814 20.1962 1.7269 19.6042 1.7269C19.0122 1.7269 18.5531 1.9086 18.1702 2.27395C17.8908 2.53965 17.6798 2.91672 17.5411 3.40319C17.4454 3.73728 17.1269 3.95023 16.7869 3.90921C16.3571 3.85646 16.0738 3.42468 16.1969 3.00268C16.3845 2.35209 16.701 1.83045 17.1425 1.43189C17.756 0.87899 18.5687 0.601562 19.5788 0.601562C20.6475 0.601562 21.5013 0.898528 22.1401 1.4905C22.7771 2.08443 23.0955 2.7995 23.0955 3.64155C23.0955 4.12802 22.9841 4.57738 22.7595 4.98571C22.5348 5.39599 22.0972 5.89418 21.4466 6.48225C21.0089 6.8769 20.7217 7.16996 20.5869 7.35752C20.4521 7.54508 20.3525 7.75998 20.288 8.00224C20.2411 8.18199 20.2079 8.44769 20.1884 8.79545C20.1767 9.01427 19.9989 9.1862 19.782 9.1862H19.2779L19.2799 9.18815Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </Svg>
  );
};

export default ChatBotIcon;
